import { CountryIsoNumber, TranslationDictionaryMapping } from '@i18n';
import { GBAddressTranslationDictionaryMapping } from '../../i18n/gb/gb-address-translation-dictionary-mapping.constant';
import { IEAddressTranslationDictionaryMapping } from '../../i18n/ie/ie-address-translation-dictionary-mapping.constant';
import { AddressTranslationDictionary } from '../../models/i18n/address-translation-dictionary.interface';

export function addressTranslationDictionaryMappingFactory(
  countryIsoNumber?: CountryIsoNumber,
): TranslationDictionaryMapping<AddressTranslationDictionary> {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return IEAddressTranslationDictionaryMapping;
    case CountryIsoNumber.GreatBritain:
    default:
      return GBAddressTranslationDictionaryMapping;
  }
}
